var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle53A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M54 39v14l-7.251.725A2.5 2.5 0 0 1 44 51.237V26.762a2.5 2.5 0 0 1 2.749-2.487L54 25v14Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M54 54V24"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7 32V22l8.274-.752A2.5 2.5 0 0 1 18 23.738v6.524a2.5 2.5 0 0 1-2.726 2.49L7 32Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m9 33-.445-.223A2.813 2.813 0 0 1 7 30.262v-6.524c0-1.065.602-2.04 1.555-2.516L9 21"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7 52V42l8.274-.752A2.5 2.5 0 0 1 18 43.738v6.524a2.5 2.5 0 0 1-2.726 2.49L7 52Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m9 53-.445-.223A2.813 2.813 0 0 1 7 50.261v-6.523c0-1.065.602-2.04 1.555-2.516L9 41"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M38.5 19.002a2.5 2.5 0 0 1 2.5 2.5v31a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-31a2.5 2.5 0 0 1 2.5-2.5h15Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M51.5 6H17l-.725 7.251A2.5 2.5 0 0 0 18.763 16H41.5a2.5 2.5 0 0 1 2.5 2.5v20.639a2.5 2.5 0 0 0 2.835 2.477l7.164-.969L54 8.5A2.5 2.5 0 0 0 51.5 6Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M54 40.636V8.5A2.5 2.5 0 0 0 51.5 6H16"
})));
SvgRectangle53A.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle53A);
export default ForwardRef;